import { TemplateChangePlan } from "./template-change-plan";

export const TemplateDowngrade = (accounting, downgrade, requester) =>
    TemplateChangePlan({
        type: "Downgrade",
        accounting,
        request: downgrade,
        requester
    });
